import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';
import produce from 'immer';

import { PROBLEM_SIDE_PANEL_MODE } from 'common.components/lesson-view.common/constants';

import * as constants from './constants';
import { LessonViewActions, LessonViewStore } from './interfaces';
import { LESSON_VIEW_MODE } from './typings';

const initialState: LessonViewStore = {
    selectedProblemId: null,
    selectedStudentId: null,
    shouldShowModal: false,
    lessonAddStudentsToLessonLoadingStatus: LOADING_STATUSES.UNSENT,
    shouldShowAssignmentSettings: false,
    selectedTab: null,
    shouldShowNotification: false,
    notificationTextId: null,
    problemStacksRequestStatus: LOADING_STATUSES.UNSENT,
    problemStacks: [],
    problemSidePanelMode: PROBLEM_SIDE_PANEL_MODE.CLOSED,
    shouldAssignInExternalLms: false,
    mode: LESSON_VIEW_MODE.DEFAULT,
    isHeadless: false,
    lessonCourseId: null,
};

const reducer = (state: LessonViewStore = initialState, action: LessonViewActions) => {
    // eslint-disable-next-line complexity,consistent-return
    return produce(state, (draft) => {
        // eslint-disable-line complexity
        switch (action.type) {
            case constants.TOGGLE_MODAL:
                if (!action.shouldShowModal) {
                    return initialState;
                }

                draft.shouldShowModal = action.shouldShowModal;
                break;

            case constants.ADD_STUDENTS_TO_LESSON_REQUEST:
                draft.lessonAddStudentsToLessonLoadingStatus = LOADING_STATUSES.LOADING;
                break;

            case constants.ADD_STUDENTS_TO_LESSON_SUCCESS:
                draft.lessonAddStudentsToLessonLoadingStatus = LOADING_STATUSES.SUCCESS;
                break;

            case constants.ADD_STUDENTS_TO_LESSON_ERROR:
                draft.lessonAddStudentsToLessonLoadingStatus = LOADING_STATUSES.ERROR;
                break;

            case constants.SET_SELECTED_STUDENT_ID:
                draft.selectedStudentId = action.selectedStudentId;
                break;

            case constants.SET_SHOULD_SHOW_ASSIGNMENT_SETTINGS:
                draft.shouldShowAssignmentSettings = action.shouldShow;
                break;

            case constants.SET_SELECTED_TAB:
                draft.selectedTab = action.selectedTab;
                break;

            case constants.TOGGLE_LESSON_NOTIFICATION:
                draft.shouldShowNotification = action.shouldShow;
                draft.notificationTextId = action.textId || null;
                break;

            case constants.GET_PROBLEM_STACKS_REQUEST:
                draft.problemStacksRequestStatus = LOADING_STATUSES.LOADING;
                break;

            case constants.GET_PROBLEM_STACKS_SUCCESS:
                const { stacks } = action.payload;

                draft.problemStacks = stacks;
                draft.problemStacksRequestStatus = LOADING_STATUSES.SUCCESS;
                break;

            case constants.GET_PROBLEM_STACKS_ERROR:
                draft.problemStacksRequestStatus = LOADING_STATUSES.ERROR;
                break;

            case constants.SET_PROBLEM_SIDEPANEL_MODE: {
                const { mode } = action.payload;

                draft.problemSidePanelMode = mode;
                break;
            }

            case constants.SET_MODE:
                const { mode } = action.payload;

                draft.mode = mode;
                break;

            case constants.SET_IS_HEADLESS:
                const { isHeadless } = action.payload;

                draft.isHeadless = isHeadless;
                break;

            case constants.SET_SHOULD_ASSIGN_IN_EXTERNAL_LMS:
                draft.shouldAssignInExternalLms = action.payload;
                break;

            case constants.SET_LESSON_COURSE_ID:
                draft.lessonCourseId = action.payload.courseId;
                break;

            default:
                break;
        }
    });
};

export default reducer;
